import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Partner } from '../../models/partner';
import { PartnerRelationship } from '../../models/PartnerRelationship';
import { PartnerService } from '../../partner-service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-edit-partnership',
  templateUrl: './edit-partnership.component.html',
  styleUrls: ['./edit-partnership.component.scss']
})
export class EditPartnershipComponent implements OnInit, OnDestroy {

  selectedGroup: any[];
  selectedItemsNow: any[] = [];
  partnerUpdate: PartnerRelationship;
  partnerRelationships: PartnerRelationship[];
  subscription: Subscription;
  processing = false;
  partnerName: string;

  @Output() onDialogOpen = new EventEmitter<boolean>();
  @Output() onDialogClose = new EventEmitter<boolean>();
  @Input() displayDialog: boolean;
  @Input() partner: Partner;
  @Input() relationshipId: number;
  @Input() partnership: PartnerRelationship;
  @Output() onRelationships = new EventEmitter<PartnerRelationship[]>();
  @Output() onError = new EventEmitter<string>();


  constructor(private partnerSvc: PartnerService) { }

  ngOnInit() {
    this.partnerName = this.partner ? this.partner.PrimaryContact : this.partnerName;
    this.partnerName = this.partnership ? this.partnership.ChildCompany.Name : this.partnerName;
  }

  dialogClose(): void {
    this.onDialogClose.emit(false);
  }

  dialogOpen(): void {
    this.onDialogOpen.emit(true);
  }

  cancelDialog(): void {
    this.displayDialog = false;
  }

  assetGroupChange(group): void {
    this.selectedGroup = group;
  }

  partnerDetailsChange(partner: PartnerRelationship): void {
    this.partnerUpdate = partner;
  }

  onPrivilegeChange(privilege): void {
    this.selectedItemsNow = privilege;
  }

  onSubmit(editPartnerForm: NgForm): void {
    if (editPartnerForm.form.valid) {
      this.processing = true;
      this.subscription = this.partnerSvc.update(this.partnerUpdate)
        .subscribe((relationships)  => {
          this.partnerRelationships = relationships['data'];
          this.onRelationships.emit(this.partnerRelationships);
          this.processing = false;
          this.displayDialog = false;
        }, error => {
          this.onError.emit('Error Occcured while Processing');
          this.processing = false;
          this.displayDialog = false;
        });
    }
  }

  ngOnDestroy() {
    if (this.subscription) { this.subscription.unsubscribe(); }
  }
}

